export default "__VITE_ASSET__MK6ACbIS__"